interface response {
  code: number;
  message: string;
}

export function clockOn (): Promise<response> {
  return request({
    url: '/gamecard/v2/share/assistance/clockOn',
    type: 'POST',
  });
}
